import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserService } from "../../services/users/user.service";
import { User } from "src/app/models/user.model";
import swal from "sweetalert2";
import { NgForm } from "@angular/forms";
import { AuthService } from "../../services/service.index";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import Swal from "sweetalert2";
// import { USERS_WHITELIST } from 'src/app/config/config';

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styles: [],
})
export class UsersComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  count: any;
  LastEvaluatedKey: any;
  loading = true;
  users = [];
  user: User = new User("", "", true, 0, false, "");
  data = [
    { id: 1, name: "Correo Electrónico" },
    { id: 2, name: "be.ID" },
  ];
  selectedSearch = this.data[0];

  firstInResponse: any;
  secondFirstInResponse: any;
  lastInResponse: any;

  prev_strt_at = [];
  pagination_clicked_count = 0;

  enable_prev_all: boolean;
  enable_next: boolean;
  enable_prev: boolean;
  almighty: any;

  constructor(public us: UserService, private auth: AuthService) {}

  ngOnInit() {
    this.loadUsers();
    this.getClaims();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getClaims() {
    this.almighty = localStorage.getItem("almighty")
      ? JSON.parse(localStorage.getItem("almighty"))
      : null;
  }

  async addUser(form: NgForm) {
    if (form.valid) {
      try {
        const res:any = await this.auth.createUser(
          form.value.email,
          form.value.password,
          form.value.name
        );

        console.log(res );
        Swal.fire({
          title: `Agregando usuario ${form.value.email}!`,
          html: "Espere unos segundos.",
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        form.reset();
        Swal.close();
        Swal.fire("Éxito!", `El usuario ${res.id} ha sido creado!`, "success");
      } catch (error) {
        Swal.fire(
          "El usuario no ha sido creado!",
          "Contacte a soporte.",
          "error"
        );
        console.log(error);
      }
    }
  }

  loadUsers() {
    this.loading = true;
    this.us.getUsersAFS("").subscribe(
      (response) => {
        this.users = [];

        this.us.getUserCount().subscribe((res: any) => {
          this.count = res.count;
        });

        this.firstInResponse = response.docs[0];
        this.lastInResponse = response.docs[response.docs.length - 1];

        for (let item of response.docs) {
          const u: User = new User(
            item.id,
            item.data().email,
            item.data().isActive || false,
            item.data().dikeffId || "",
            item.data().isGoldPlan || false,
            item.data().displayName || ""
          );
          this.users.push(u);
        }

        // initialize values
        this.prev_strt_at.push(null);

        this.enable_next = true;
        this.enable_prev_all = false;
        this.enable_prev = false;

        // push first item to use for Previous action
        // this.push_prev_startAt(this.firstInResponse);
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  loadMoreUsersAFS() {
    this.pagination_clicked_count++;
    console.log(this.pagination_clicked_count);
    console.log(this.prev_strt_at.length);
    this.us.getUsersAFS(this.lastInResponse).subscribe(
      (response) => {
        this.users = [];
        this.firstInResponse = response.docs[0];
        this.lastInResponse = response.docs[response.docs.length - 1];

        for (let item of response.docs) {
          const u: User = new User(
            item.id,
            item.data().email,
            item.data().isActive || false,
            item.data().dikeffId || "",
            item.data().isGoldPlan || false,
            item.data().displayName || ""
          );
          this.users.push(u);
        }

        // initialize values
        this.prev_strt_at.push(this.lastInResponse);

        if (this.pagination_clicked_count > 1) {
          this.enable_prev_all = true;
        }

        this.enable_next = true;
        this.enable_prev = true;

        // push first item to use for Previous action
        // this.push_prev_startAt(this.firstInResponse);
      },
      (error) => {
        console.log(error);
      }
    );
    this.loading = false;
  }

  // goBackUsersAFS() {
  //     this.us.getUsersAFS(this.prev_strt_at[this.pagination_clicked_count - 1]).subscribe(response => {

  //         this.users = [];

  //         this.lastInResponse = response.docs[response.docs.length - 1];

  //         for (let item of response.docs) {
  //             const u: User = new User(
  //                 item.id,
  //                 item.data().email,
  //                 item.data().isActive || false,
  //                 item.data().dikeffId || '',
  //                 item.data().isGoldPlan || false,
  //                 item.data().displayName || '');
  //             this.users.push(u);
  //         }

  //         // initialize values
  //         this.prev_strt_at.push(this.lastInResponse);
  //         if (this.pagination_clicked_count <= 0) {
  //             this.pagination_clicked_count = 0;
  //             this.enable_prev_all = false
  //             this.enable_prev = false;
  //         }

  //         this.enable_next = true;
  //         this.pagination_clicked_count--;
  //         this.prev_strt_at.length = this.pagination_clicked_count +1;
  //         console.log("ARRAY ", this.prev_strt_at.length);
  //         console.log("CLICKS ", this.pagination_clicked_count);
  //     }, error => {
  //         console.log(error);
  //     });
  //     this.loading = false;
  // }

  goBackAllUsersAFS() {
    this.us.getUsersAFS("").subscribe(
      (response) => {
        this.users = [];

        this.us.getUserCount().subscribe((res: any) => {
          this.count = res.count;
        });

        this.lastInResponse = response.docs[response.docs.length - 1];

        for (let item of response.docs) {
          const u: User = new User(
            item.id,
            item.data().email,
            item.data().isActive || false,
            item.data().dikeffId || "",
            item.data().isGoldPlan || false,
            item.data().displayName || ""
          );
          this.users.push(u);
        }

        // initialize values
        this.pagination_clicked_count = 0;

        if (this.pagination_clicked_count < 1) {
          this.enable_prev_all = false;
          this.enable_prev = false;
        }

        this.enable_next = true;

        // push first item to use for Previous action
        // this.push_prev_startAt(this.firstInResponse);
      },
      (error) => {
        console.log(error);
      }
    );
    this.loading = false;
  }

  loadSearch(searchKey: any) {
    if (searchKey.length <= 0) {
      this.loadUsers();
    } else {
      if (this.selectedSearch.id === 1) {
        this.us.searchUserByEmail(searchKey).subscribe(
          (response) => {
            this.users = [];
            for (let item of response.docs) {
              const u: User = new User(
                item.id,
                item.data().email,
                item.data().isActive || false,
                item.data().dikeffId || "",
                item.data().isGoldPlan || false,
                item.data().displayName || ""
              );
              this.users.push(u);
            }
          },
          (error) => {
            console.log(error);
          }
        );
        this.loading = false;
      } else {
        this.us.searchUserByDikeffId(searchKey).subscribe(
          (response) => {
            this.users = [];
            for (let item of response.docs) {
              const u: User = new User(
                item.id,
                item.data().email,
                item.data().isActive,
                item.data().dikeffId || "",
                item.data().isGoldPlan || false,
                item.data().displayName === "0" ? " " : item.data().displayName
              );
              this.users.push(u);
            }
          },
          (error) => {
            console.log(error);
          }
        );
        this.loading = false;
      }
      this.enable_next = true;
      this.enable_prev = true;
    }
  }

  parseDate(date: string) {
    const date2 = new Date(date);
    return date2.toLocaleDateString("es-LA");
  }

  deactivateUser(user: User) {
    const swalWithBootstrapButtons = swal.mixin({
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estás seguro?",
        text:
          "Se desactivará la cuenta be.ID: " +
          user.dikeffId +
          ", Correo: " +
          user.email,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#06d79c",
        cancelButtonColor: "#ef5350",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          this.us
            .activateDeactivateUser(user.uid, false)
            .then((res) => {
              this.loadUsers();
            })
            .catch((err) => {
              console.log(err);
            });

          swalWithBootstrapButtons.fire(
            "Desactivado",
            "El usuario ha sido desactivado.",
            "success"
          );
        } else if (
          // Read more about handling dismissals
          result.dismiss === swal.DismissReason.cancel
        ) {
          console.log("Canceled");
        }
      });
  }

  activateUser(user: User) {
    const swalWithBootstrapButtons = swal.mixin({
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estás seguro?",
        text:
          "Se activará la cuenta be.ID: " +
          user.dikeffId +
          ", Correo: " +
          user.email,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#06d79c",
        cancelButtonColor: "#ef5350",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          this.us
            .activateDeactivateUser(user.uid, true)
            .then((res) => {
              this.loadUsers();
            })
            .catch((err) => {
              console.log(err);
            });

          swalWithBootstrapButtons.fire(
            "Activado",
            "El usuario ha sido activado.",
            "success"
          );
        } else if (
          // Read more about handling dismissals
          result.dismiss === swal.DismissReason.cancel
        ) {
          console.log("Canceled");
        }
      });
  }

  deactivateGoldUser(user: User) {
    const swalWithBootstrapButtons = swal.mixin({
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estás seguro?",
        text:
          "Se desactivará la cuenta Gold de be.ID: " +
          user.dikeffId +
          ", Correo: " +
          user.email,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#06d79c",
        cancelButtonColor: "#ef5350",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          this.us
            .activateDeactivateGoldUser(user.uid, false)
            .then((res) => {
              this.loadUsers();
            })
            .catch((err) => {
              console.log(err);
            });

          swalWithBootstrapButtons.fire(
            "Desactivado",
            "El usuario ha sido desactivado.",
            "success"
          );
        } else if (
          // Read more about handling dismissals
          result.dismiss === swal.DismissReason.cancel
        ) {
          console.log("Canceled");
        }
      });
  }

  activateGoldUser(user: User) {
    const swalWithBootstrapButtons = swal.mixin({
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estás seguro?",
        text:
          "Se activará la cuenta Gold de be.ID: " +
          user.dikeffId +
          ", Correo: " +
          user.email,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#06d79c",
        cancelButtonColor: "#ef5350",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          this.us
            .activateDeactivateGoldUser(user.uid, true)
            .then((res) => {
              this.loadUsers();
            })
            .catch((err) => {
              console.log(err);
            });
          swalWithBootstrapButtons.fire(
            "Activado",
            "El usuario ha sido activado.",
            "success"
          );
        } else if (
          // Read more about handling dismissals
          result.dismiss === swal.DismissReason.cancel
        ) {
          console.log("Canceled");
        }
      });
  }

  loadEditModal(userToModal: User) {
    this.user = userToModal;
  }

  updateUser(f: NgForm) {
    const swalWithBootstrapButtons = swal.mixin({
      buttonsStyling: true,
    });

    try {
      if (f.valid) {
        if (f.value.name !== "") {
          this.user.displayName = f.value.name;
        }
        if (f.value.email !== "") {
          this.user.email = f.value.email;
        }
        if (f.value.dikeffId !== "") {
          this.user.dikeffId = f.value.dikeffId;
        }
        if (f.value.referralId !== "") {
          this.user.referralId = f.value.referralId;
        }

        this.us.putUsers(this.user).then((res: any) => {
          // this.loadUsers();
          swalWithBootstrapButtons
            .fire("Listo!", "El usuario ha sido editado con éxito.", "success")
            .then(() => {
              this.loadUsers();
            });
        });
      }
    } catch (error) {
      swalWithBootstrapButtons
        .fire("error!", "El usuario no ha sido editado.", "error")
        .then(() => {
          // this.loadUsers();
        });
      console.log(error);
    }
  }

  async activateAll() {
    if (this.almighty) {
      var count = 0;
      try {
        const userFB = await this.us.getAll();
        userFB.forEach(async (user) => {
          console.log(user.data());
          this.us.activateDeactivateUser(user.id, true).then((res) => {
            console.log(user.id, "true", count++);
          });
        });
        console.log("All users activated");
      } catch (error) {
        console.log(error);
      }
    }
  }
}
